//add placeholders to list field inputs based on column headers

($ => {
  $(document).on('gform_post_render', function (event, formId) {
    const listFields = $('.gfield--type-list');

    listFields.each(function () {
      const $listField = $(this);
      const $header = $listField.find('.gfield_list_header');
      const $rows = $listField.find('.gfield_list_group');

      if ($header.length === 0 || $rows.length === 0) {
        return;
      }

      const headers = [];
      $header.find('.gfield_header_item').each(function () {
        const headerText = $(this).text().trim();
        const cleanHeaderText = headerText.replace(' *', '').trim();
        headers.push(cleanHeaderText);
      });

      $rows.each(function () {
        const $row = $(this);
        const $inputs = $row.find('input[type="text"]');

        $inputs.each(function (index) {
          if (headers[index]) {
            $(this).attr('placeholder', headers[index]);
          }
        });
      });

      $listField.on('click', '.add_list_item', function () {
        setTimeout(() => {
          const $newRow = $listField.find('.gfield_list_group').last();
          const $newInputs = $newRow.find('input[type="text"]');

          $newInputs.each(function (index) {
            if (headers[index]) {
              $(this).attr('placeholder', headers[index]);
            }
          });
        }, 100);
      });
    });
  });
})(jQuery);
